import type { UserSalutation } from './userAccount';

export enum ProfileBenefitType {
  KEY_EMERGENCY_SERVICE = 'KEY_EMERGENCY_SERVICE',
  RENT_LEGAL_ADVICE = 'RENT_LEGAL_ADVICE',
}

export interface ProfileBenefitsUserData {
  firstName: string;
  lastName: string;
  city: string;
  houseNumber: string;
  postcode: string;
  salutation: UserSalutation;
  street: string;
  policyNumber: string;
}

export interface ProfileBenefitsUserDataInput {
  firstName: string;
  lastName: string;
  city: string;
  houseNumber: string;
  postcode: string;
  salutation: UserSalutation;
  street: string;
}

export type ProfileBenefitsStatusResponse = {
  ssoId: string;
  customerNumber: string;
  keyEmergencyService: boolean;
  rentLegalAdvice: boolean;
  plusProduct: boolean;
};

export interface StartContractRequest extends ProfileBenefitsUserData {
  benefitType?: ProfileBenefitType;
}

export interface GrantContractBenefit {
  benefitType: ProfileBenefitType;
}

export type InsuranceState = ProfileBenefitsStatusResponse;
